'use client';
import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const OdooDevelopmentAnimation: React.FC = () => {
    useEffect(() => {
        const yellowList: any = document.querySelector('.yellow-list');
        const blueList: any = document.querySelector('.blue-list');

        // Duplicate the list items to create a seamless loop effect
        yellowList.innerHTML += yellowList.innerHTML;
        blueList.innerHTML += blueList.innerHTML;
        // Get the width of the list for the animation distance
        const yellowListWidth = yellowList.scrollWidth / 8;
        const blueListWidth = blueList.scrollWidth / 8;

        // Animation for yellow list
        gsap.to('.yellow-list', {
            x: -yellowListWidth,
            ease: 'none', // Smooth easing function
            scrollTrigger: {
                trigger: '.yellow-ribbon',
                start: 'top 80%',
                end: 'bottom top',
                scrub: 1, // Slow down the animation
            },
        });
        // Animation for blue list
        gsap.to('.blue-list', {
            x: blueListWidth,
            ease: 'none', // Smooth easing function
            scrollTrigger: {
                trigger: '.blue-ribbon',
                start: 'top 80%',
                end: 'bottom top',
                scrub: 1, // Slow down the animation
            },
        });
    }, []);
    return (
        <div className="dark:bg-black">
            <div className="container-fluid">
                <div className="row grid lg:grid-cols-12 relative">
                    <div className="text-center lg:col-span-12">
                        <div id="container-box">
                            <div className="horizontal-main">
                                <div>
                                    <div className="ribbon yellow-ribbon">
                                        <ul className="yellow-list">
                                            <li className="yellow-item">Enhanced Marketing</li>
                                            <li className="yellow-item">Stronger Customer Service</li>
                                            <li className="yellow-item">Automated Workflows</li>
                                            <li className="yellow-item">Simplified Reporting</li>
                                            <li className="yellow-item">Scalable Growth</li>
                                            <li className="yellow-item">Mobile Accessibility</li>
                                            <li className="yellow-item">Increased Productivity</li>
                                            <li className="yellow-item">Improved Profitability</li>
                                            <li className="yellow-item">Competitive Advantage</li>
                                            <li className="yellow-item">Future-Proof Business</li>
                                            <li className="yellow-item">Enhanced Marketing</li>
                                            <li className="yellow-item">Stronger Customer Service</li>
                                            <li className="yellow-item">Automated Workflows</li>
                                            <li className="yellow-item">Simplified Reporting</li>
                                            <li className="yellow-item">Mobile Accessibility</li>
                                            <li className="yellow-item">Increased Productivity</li>
                                            <li className="yellow-item">Improved Profitability</li>
                                            <li className="yellow-item">Competitive Advantage</li>
                                            <li className="yellow-item">Future-Proof Business</li>
                                        </ul>
                                    </div>
                                    <div className="ribbon blue-ribbon">
                                        <ul className="blue-list">
                                            <li className="blue-item">Streamlined Operations</li>
                                            <li className="blue-item">Centralized Data</li>
                                            <li className="blue-item">Enhanced Visibility</li>
                                            <li className="blue-item">Improved Collaboration</li>
                                            <li className="blue-item">Boosted Efficiency</li>
                                            <li className="blue-item">Reduced Costs</li>
                                            <li className="blue-item">Real-Time Insights</li>
                                            <li className="blue-item">Data-Driven Decisions</li>
                                            <li className="blue-item">Inventory Management</li>
                                            <li className="blue-item">Improved Sales</li>
                                            <li className="blue-item">Streamlined Operations</li>
                                            <li className="blue-item">Centralized Data</li>
                                            <li className="blue-item">Enhanced Visibility</li>
                                            <li className="blue-item">Improved Collaboration</li>
                                            <li className="blue-item">Boosted Efficiency</li>
                                            <li className="blue-item">Reduced Costs</li>
                                            <li className="blue-item">Real-Time Insights</li>
                                            <li className="blue-item">Data-Driven Decisions</li>
                                            <li className="blue-item">Inventory Management</li>
                                            <li className="blue-item">Improved Sales</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OdooDevelopmentAnimation;
